import React from 'react';
import styled from 'styled-components';
import { colors, spacing, breakpoints } from '../../constants/theme';
import { useAuth } from '../../contexts/AuthContext';

const CreditsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
  background: ${colors.background.secondary};
  border: 1px solid ${colors.background.tertiary};
  border-radius: 12px;
  padding: ${spacing.sm} ${spacing.md};
  color: ${colors.text.primary};
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    background: ${colors.background.tertiary};
    border-color: ${colors.primary.main}40;
    transform: translateY(-1px);
  }

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 12px;
    padding: ${spacing.xs} ${spacing.sm};
  }
`;

const CreditsIcon = styled.span`
  font-size: 16px;
  color: ${colors.primary.main};
  
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 14px;
  }
`;

const CreditsNumber = styled.span`
  color: ${colors.primary.main};
  font-weight: 600;
  font-size: 15px;
  
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 13px;
  }
`;

const CreditsLabel = styled.span`
  color: ${colors.text.secondary};
  
  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

interface CreditsBalanceProps {
  onClick?: () => void;
}

const CreditsBalance: React.FC<CreditsBalanceProps> = ({ onClick }) => {
  const { companyData } = useAuth();

  // Get credits from company data (already loaded by AuthContext)
  const credits = companyData?.creditBalance || 0;

  const formatCredits = (num: number): string => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toString();
  };

  return (
    <CreditsContainer onClick={onClick}>
      <CreditsIcon>💎</CreditsIcon>
      <CreditsNumber>
        {companyData ? formatCredits(credits) : '...'}
      </CreditsNumber>
      <CreditsLabel>Credits</CreditsLabel>
    </CreditsContainer>
  );
};

export default CreditsBalance;
